import dayjs from 'dayjs'
import React, { FC } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import DateStepInput from '../../../../components/inputs/DateStepInput'
import { InvoiceExtensionFormFields } from '../InvoiceExtensionPage'

interface NewInvoiceDueDateStepProps {
	form: UseFormReturn<InvoiceExtensionFormFields>
}

const NewInvoiceDueDateStep: FC<NewInvoiceDueDateStepProps> = ({ form }) => {
	const minDate = dayjs(form.watch('currentDueDate'))
	const maxDate = dayjs(form.watch('currentDueDate')).add(14, 'day')
	const { t } = useTranslation('pages_invoiceExtension')

	return (
		<DateStepInput<InvoiceExtensionFormFields>
			form={form}
			fieldName='newDueDate'
			minDate={minDate}
			maxDate={maxDate}
			label={t('newInvoiceDueDateStep.dateLabel')}
			description={t('newInvoiceDueDateStep.description1')}
		/>
	)
}

export default NewInvoiceDueDateStep
